import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'components/Popup/popup';

const SendMultipleWorkOrderPopup = ({...props}) => {
  return (
    <Popup ref={(ref) => { this.sendMultiplePopup = ref; }} isHasFaded={true} className='send-multi-popup'>
      <div style={{padding: '0 15px'}}>All selected items will be sent to their assignee. Continue?</div>
      <ul className='wo-popup-bottom-btn' style={{ marginTop: 0, borderTop: 0 }}>
        <li>
          <button
            className='btn btn-primary btn-siteone-default btn-wo-edit'
            onClick={props.onCancel}>Cancel
          </button>
        </li>
        <li>
          <button
            className='btn btn-primary btn-siteone'
            onClick={props.onSend}>Send all
          </button>
        </li>
      </ul>
    </Popup>
  );
};

SendMultipleWorkOrderPopup.propTypes = {
  onCancel: PropTypes.func,
  onSend: PropTypes.func
};

export default SendMultipleWorkOrderPopup;



// WEBPACK FOOTER //
// ./src/Punch-List/Components/SendMultipleWorkOrderPopup.js